import { useListenKeyboard, useScrollLock } from "@imwebme/clay-hooks";
import { Portal } from "../../utilities";
import { ModalOverlay } from "../Modal.overlay";
import { ModalProvider } from "../Modal.providers";
import { VisualModalBody } from "./VisualModal.body";
import { VisualModalContainer } from "./VisualModal.container";
import { VisualModalFooter } from "./VisualModal.footer";
import { VisualModalHeader } from "./VisualModal.header";
import type { VisualModalProps } from "./VisualModal.types";
import { VisualModalVisual } from "./VisualModal.visual";

const VisualModal = ({
  closeOnEsc = true,
  setClose,
  isOpen,
  closeOnBackdrop,
  children,
  width,
}: VisualModalProps) => {
  useScrollLock({ enable: isOpen });

  useListenKeyboard({
    key: "Escape",
    handler: setClose,
    enable: closeOnEsc,
  });

  return isOpen ? (
    <Portal>
      <ModalProvider setClose={setClose}>
        <ModalOverlay closeOnBackdrop={closeOnBackdrop} setClose={setClose}>
          <VisualModalContainer width={width}>{children}</VisualModalContainer>
        </ModalOverlay>
      </ModalProvider>
    </Portal>
  ) : null;
};

const VisualModalNamespace = Object.assign(VisualModal, {
  /**
   * Clay가 wrapper이기 때문에, height, width 다양한 커스텀이 가능합니다.
   */
  Visual: VisualModalVisual,
  Header: VisualModalHeader,
  Body: VisualModalBody,
  Footer: VisualModalFooter,
});

export { VisualModalNamespace as VisualModal };
